import React from 'react';
import { styled } from '@mui/material';
import { RESOURCE_CARD_MIN_WIDTH, RESOURCE_SECTION_CARD_GUTTER } from 'themes/constants';

const withBaseClass = (base: string, className?: string): string =>
  className ? `${base} ${className}` : base;

/**
 * Card grid for resource sections. Auto-fill tracks never go below RESOURCE_CARD_MIN_WIDTH,
 * so a narrow container drops a card per row instead of shrinking cards further; the parent's
 * RESOURCE_SECTION_MAX_WIDTH caps the count per row.
 */
const StyledResourceCardGrid = styled('ul')(() => ({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  display: 'grid',
  gridTemplateColumns: `repeat(auto-fill, minmax(${RESOURCE_CARD_MIN_WIDTH}px, 1fr))`,
  gap: RESOURCE_SECTION_CARD_GUTTER,
}));

// Centers the fluid card (capped at its design width) in its track.
const StyledResourceCardGridCell = styled('li')(() => ({
  display: 'flex',
  justifyContent: 'center',
  minWidth: 0,
}));

// Base BEM classes are automation hooks; callers add a block-specific class via className.
export const ResourceCardGrid = ({ className, ...props }: React.ComponentProps<'ul'>) => (
  <StyledResourceCardGrid className={withBaseClass('resource-card-grid', className)} {...props} />
);

export const ResourceCardGridCell = ({ className, ...props }: React.ComponentProps<'li'>) => (
  <StyledResourceCardGridCell
    className={withBaseClass('resource-card-grid__cell', className)}
    {...props}
  />
);
